/**
 * Whose mail the Mail page shows (Akhil, 2026-09-21).
 *
 * Enquiries land in one shared mailbox with the responsible purchaser on Cc. A purchaser sees
 * the threads they are on — To or Cc equals their login — and cannot widen that; only a
 * purchase manager sees everyone's and gets the "Addressed to" filter (seeded from the mailbox
 * setting, which is now a manager's convenience). A view rule, enforced here for the list; the
 * proxy still runs every request as one service account (`A7`), so it is not a permission.
 */
import type { Role } from './types'

export interface MailScope {
  addressedTo: string | null
  /** The filter control is hidden and the address cannot be changed. */
  locked: boolean
  /** A locked scope with no address to lock to — the identity has not resolved. Show nothing. */
  unresolved?: boolean
}

export function mailScopeFor(role: Role | null, ownEmail: string, mailboxSetting: string | null): MailScope {
  if (role === 'purchase_manager') return { addressedTo: mailboxSetting || null, locked: false }
  const own = ownEmail.trim().toLowerCase()
  if (own === '') return { addressedTo: null, locked: true, unresolved: true }
  return { addressedTo: own, locked: true }
}
